/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_UnknownInputs */

const en_fw_bm_unknown = /** @type {(inputs: Fw_Bm_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unreported`)
};

const id_fw_bm_unknown = /** @type {(inputs: Fw_Bm_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tak dilaporkan`)
};

/**
* | output |
* | --- |
* | "unreported" |
*
* @param {Fw_Bm_UnknownInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_unknown = /** @type {((inputs?: Fw_Bm_UnknownInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_UnknownInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_unknown(inputs)
	return en_fw_bm_unknown(inputs)
});